// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"a05cb067","453":"f7e1f854","510":"14865702","582":"dbe3b393","722":"d7f9e30b","748":"858b49e7","778":"57a03309","882":"88ff1b45"}[chunkId] + ".chunk.js";
};